import React, { useTransition } from "react";
import ScansCard from "./ScansCard";
import ScansOverview from "./ScansOverview";
import { CustomGridLayout } from "./CustomiseLayout";
import ExportToCsv from "./ExportDataIntoExcel";
import "./index.scss";
import { useTranslation } from 'react-i18next';
export default function ScansBoard(props) {
  const cols = 2; // Number of columns
  const rowHeight = 100; // Height of each row
  const width = 300; // Width of the grid container

  const { cardsData } = props;
  const {t}=useTranslation();
  const DRAG_AND_DROP=t("DRAG_AND_DROP")
  const generateLayout = () => {
    return cardsData.map((item, index) => {
      const cols = item.type === "METRIC_CARD" ? 1 : 2; 
      return ({
        i:
          item.type === "METRIC_CARD"
            ? `METRIC_CARD_${index}`
            : `METRIC_CARD_LITE_${index}`,
        x: index % cols,
        y: Math.floor(index / cols),
        w: item.type === "METRIC_CARD" ? 2 : 1,
        h: item.type === "METRIC_CARD" ? 0.8 : 0.5,
      })
    });
  };

  return (
    <React.Fragment>
      <div className="flex gap-3 align-items-center">
        {props.getDRDTooltip('drd-scan-board', DRAG_AND_DROP)}
        {/* <ExportToCsv jsonData={props.excelData} filename={"CardData.csv"} /> */}
      </div>
      <br/>
      <CustomGridLayout
        className="layout metric-card"
        layout={generateLayout()}
        onLayoutChange={(e) => console.log(e)}
        cols={cols}
        rowHeight={rowHeight}
        width={width}
        isResizable={false}
      >
        {cardsData.map((card, index) => {
          const {
            key,
            name,
            time,
            imageSrc,
            bgColor,
            patients,
            type,
            title,
            value,
          } = card;
          return type === "METRIC_CARD" ? (
            <div
              key={`METRIC_CARD_${index}`}
              className="flex gap-2 align-items-center p-2"
              style={{ width: '100% !important', border: '1px solid var(--surface-border)', paddingTop: '32px !important', borderRadius: '4px' }}
            >
              <div className="flex align-items-center gap-2" style={{ width: '100% !important'}}>
              <ScansCard
                index={index}
                key={key}
                name={name}
                time={time}
                imageSrc={imageSrc}
                bgColor={bgColor}
                patients={patients}
              />
              </div>
            </div>
          ) : (
            <div
              key={`METRIC_CARD_LITE_${index}`}
              className="grid justify-content-between"
              style={{
                height: 60,
                width: "50%",
                padding: "1rem",
              }}
            >
              <ScansOverview
                key={key}
                title={title}
                value={value}
                imageSrc={imageSrc}
              />
            </div>
          );
        })}
      </CustomGridLayout>
    </React.Fragment>
  );
}
